import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';

export const PRODUCT_COUPON_TYPES = new Map<
  ProductTypeEnum | string,
  COUPON_TYPE[]
>([
  [
    ProductTypeEnum.AUTOCALL,
    [
      COUPON_TYPE.NONE,
      COUPON_TYPE.FIXED,
      COUPON_TYPE.SNOWBALL,
      COUPON_TYPE.CONDITIONAL,
    ],
  ],
  [
    ProductTypeEnum.AUTOCALL_GROWTH_AT_MATURITY,
    [COUPON_TYPE.FIXED, COUPON_TYPE.SNOWBALL, COUPON_TYPE.CONDITIONAL],
  ],
  [ProductTypeEnum.BONUS_CERTIFICATE, []],
  [ProductTypeEnum.CAPPED_FLOOR_DELTA_N, []],
  [
    ProductTypeEnum.CLN,
    [
      COUPON_TYPE.NONE,
      COUPON_TYPE.FIXED,
      COUPON_TYPE.FLOATING,
      COUPON_TYPE.FIXED_TO_FLOATING,
      // TODO: Waiting for more details from Stuart/James/Ben
      // COUPON_TYPE.FLOATING_TO_FIXED,
      // COUPON_TYPE.FIXED_TO_FLOATING_SWITCHABLE,
    ],
  ],
  [ProductTypeEnum.DISCOUNT_CERTIFICATE, []],
  [
    ProductTypeEnum.DUAL_CURRENCY_NOTE,
    [
      COUPON_TYPE.FIXED,
      COUPON_TYPE.FLOATING,
      // COUPON_TYPE.FLOATING_TO_FIXED, // TODO: Waiting for more details from Stuart/James/Ben
    ],
  ],
  [
    ProductTypeEnum.FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE,
    [COUPON_TYPE.FIXED_TO_FLOATING, COUPON_TYPE.FLOATING_TO_FIXED],
  ],
  [ProductTypeEnum.FIXED_RATE_NOTE, [COUPON_TYPE.FIXED]],
  [ProductTypeEnum.FLOATING_RATE_NOTE, [COUPON_TYPE.FLOATING]],
  [ProductTypeEnum.EQ_ISSUER_CALLABLE, [COUPON_TYPE.FIXED]],
  [
    ProductTypeEnum.PARTICIPATION_NOTE,
    [
      COUPON_TYPE.NONE,
      COUPON_TYPE.CALL,
      COUPON_TYPE.CONDITIONAL,
      COUPON_TYPE.DIGITAL,
      COUPON_TYPE.FLOATING,
      COUPON_TYPE.FIXED,
    ],
  ],
  [
    ProductTypeEnum.PERFORMANCE_LINKED_COUPON,
    [
      COUPON_TYPE.CALL,
      COUPON_TYPE.FIXED_TO_CALL,
      COUPON_TYPE.FORWARD,
      COUPON_TYPE.FIXED_TO_FORWARD,
      COUPON_TYPE.DIGITAL,
      COUPON_TYPE.FIXED_TO_DIGITAL,
      COUPON_TYPE.CONDITIONAL,
    ],
  ],
  [
    ProductTypeEnum.PRDC,
    [
      COUPON_TYPE.FIXED,
      COUPON_TYPE.FIXED_TO_FORWARD,
      COUPON_TYPE.FORWARD,
      COUPON_TYPE.DIGITAL,
      COUPON_TYPE.FIXED_TO_DIGITAL,
    ],
  ],
  // TODO: Waiting for more details from Stuart/James/Ben
  // [ProductTypeEnum.RANGE_ACCRUAL_EQ, [COUPON_TYPE.RANGE_ACCRUAL]],
  // [ProductTypeEnum.RANGE_ACCRUAL_RATES, [COUPON_TYPE.RANGE_ACCRUAL]],
  [ProductTypeEnum.REVERSE_CONVERTIBLE, [COUPON_TYPE.FIXED]],
  [ProductTypeEnum.SUPERTRACKER, []],
  [
    ProductTypeEnum.TARGET_REDEMPTION_EQ,
    [
      COUPON_TYPE.CONDITIONAL,
      // TODO: Waiting for more details from Stuart/James/Ben
      // COUPON_TYPE.CALL,
      // COUPON_TYPE.DIGITAL
    ],
  ],
  [
    ProductTypeEnum.RANGE_ACCRUAL,
    [COUPON_TYPE.RANGE_ACCRUAL, COUPON_TYPE.FIXED_TO_RANGE_ACCRUAL],
  ],
  [ProductTypeEnum.FX_DIGITAL_COUPON_NOTE, [COUPON_TYPE.FIXED_AND_CONDITIONAL]],
  [ProductTypeEnum.DROP_BACK_CERTIFICATE, [COUPON_TYPE.FIXED]],
]);
